// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import { PICKER_WIDGETS_LOAD, PICKER_INFO_LOAD, PICKER_SET_TEMPLATE } from './constants';
import config from 'cfg';
import auth from 'dash-front/auth';

export const setWidgets = (widgets, set) => dispatch => {
    return dispatch({
        type: PICKER_WIDGETS_LOAD,
        payload: {
            set,
            widgets,
        },
    });
};

export const setInfo = (data, set) => dispatch => {
    return dispatch({
        type: PICKER_INFO_LOAD,
        payload: {
            set,
            data,
        },
    });
};

export const loadWidgets = () => dispatch => {
    return fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}&social=true`)
        .then(response => response.json())
        .then(({ widgets }) => {
            return dispatch({
                type: PICKER_WIDGETS_LOAD,
                payload: {
                    set: 'all',
                    widgets,
                },
            });
        });
};

export const setTemplate = template => dispatch => {
    return dispatch({
        type: PICKER_SET_TEMPLATE,
        payload: template,
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/actions.js
 **/